/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
// import MenuMobile from './scripts/menu-mobile';
import Accordion from './scripts/accordion';
// import StickyHeader from './scripts/sticky-header';
import ShareBar from './scripts/share-bar';
import StickyCtaBar from './scripts/sticky-cta-bar';
import StickContentButton from './scripts/sticky-content-button';
import VideoHandler from './scripts/video-handler';
import OverlayMenu from './scripts/overlay-menu';
import PostProgressBar from './scripts/post-progress-bar';

const scripts = [
  PageStatus,
  Accordion,
  PostProgressBar,
  ShareBar,
  StickyCtaBar,
  StickContentButton,
  VideoHandler,
  OverlayMenu
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});

// Vendors
// import './vendors/';
